import { useCallback, useEffect, useState } from "react";

import { api_without_cancellation } from "@/api/api";

const useLibraryDocuments = (initialParams = {}) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [params, setParams] = useState(initialParams);

  const fetchDocuments = useCallback(
    async (overrideParams) => {
      const queryParams = overrideParams || params;
      setLoading(true);
      setError(null);
      try {
        const response = await api_without_cancellation.get("/api/document-library/documents/", {
          params: queryParams,
        });
        setDocuments(response.data);
        return response.data;
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [params]
  );

  useEffect(() => {
    fetchDocuments();
  }, [params]);

  const refetch = useCallback(
    (newParams) => {
      if (newParams) {
        setParams((prev) => ({ ...prev, ...newParams }));
      } else {
        fetchDocuments();
      }
    },
    [fetchDocuments]
  );

  return { documents, loading, error, params, setParams, refetch };
};

export default useLibraryDocuments;
